import { isPCShop, isWeapp, isWeb, isReactNative } from 'yofobasement/utils/runtime';

export default {
  setItem: (key, value) => {
    if (isReactNative()) {
      const StorageUtil = globalThis.StorageUtil;
      return (async () => {
        if (typeof value === 'string') {
          await StorageUtil.setItem(key, value);
        } else {
          await StorageUtil.setItem(key, JSON.stringify(value));
        }
      })();
    }
    if (isWeb() || isPCShop()) {
      localStorage.setItem(key, value);
      return;
    }
    if (isWeapp()) {
      wx.setStorageSync(key, value);
      return;
    }
    if (isReactNative()) {
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      } else {
        value = String(value);
      }
      global.setItems(key, value);
      return;
    }
  },
  getItem: (key, defaultValue) => {
    if (isReactNative()) {
      const StorageUtil = globalThis.StorageUtil;
      return (async () => {
        const value = await StorageUtil.getItem(key);
        return value || defaultValue;
      })();
    }
    if (isWeb() || isPCShop()) {
      return localStorage.getItem(key) || defaultValue;
    }
    if (isWeapp()) {
      return wx.getStorageSync(key) || defaultValue;
    }
    if (isReactNative()) {
      return global.getItems(key);
    }
  },
  removeItem: (key) => {
    if (isReactNative()) {
      const StorageUtil = globalThis.StorageUtil;
      return (async () => {
        await StorageUtil.removeItem(key);
      })();
    }
    if (isWeb()) {
      localStorage.removeItem(key);
      return;
    }
    if (isWeapp()) {
      return wx.removeStorageSync(key);
    }
    if (isReactNative()) {
      global.removeItems(key);
      return;
    }
  },
  getAllKeys: () => {}
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/AsyncStorage.js